export enum OENActionCommand {
  // CLOSER
  DESTROY_INSTANCES,
  ABORT,
  UNLOCK_MODIFY,
  UNLOCK_AMEND_MARKUP,
}
